import {fabric} from 'fabric';
import {fabricGif} from '~/common/canvas/animation/gif/Gif';

fabric.Gif = fabric.util.createClass(fabric.Image, {
  type: 'gif',
  originalUrl: '',
  initialize(options, extra) {
    options || (options = {});
    this.callSuper('initialize', options, extra);
  },

  toObject(propertiesToInclude) {
    const {src, ...object} = this.callSuper(
      'toObject',
      ['originalUrl'].concat(propertiesToInclude)
    );
    return object;
  },
});

fabric.Gif.fromURL = (url, callback, imgOptions) => {
  fabric.util.loadImage(url, (img, isError) => {
    callback && callback(new fabric.Gif(img, imgOptions), isError);
  });
};

fabric.Gif.fromObject = (object, callback) =>
  fabricGif(object.originalUrl, {originalUrl: object.originalUrl}, object.frameWidth).then(
    (gif) => {
      gif.set({...object});
      callback(gif, false);
    }
  );
